export class TeamLeadProjectInput{
    teamLeadId: number = 0
    userId: number = 0
    projectsIds: number[]
}
